// @flow
import React, { Component } from 'react';
import { FormGroup, Col, FormControl, ControlLabel } from 'react-bootstrap';

class SliderInput extends Component<{
  title?: string,
  placeholder?: string,
  defaultValue?: number,
  disabled?: boolean,
  min: number,
  max: number,
  step?: number,
  onChange?: Function,
}, {
  value: number,
}> {
  defaultProps: {
    title: 'new slider',
    placeholder: '',
    defaultValue: 50,
    disabled: false,
    step: 1,
    onChange: () => {},
  }

  constructor(props: Object) {
    super(props);
    this.state = {
      value: props.defaultValue,
    };
  }

  onNumberChanged(e: Object) {
    let number = +e.target.value || this.props.defaultValue;
    number = (number > this.props.max) ? this.props.max : number;
    number = (number < this.props.min) ? this.props.min : number;
    this.setState({ value: number });

    if (this.props.onChange) this.props.onChange(number);
  }

  input: Object;

  render(): React.Node {
    return (
      <FormGroup controlId="formHorizontalEmail">
        <Col componentClass={ControlLabel} sm={2}>
          {this.props.title}
        </Col>
        <Col sm={2}>
          <FormControl
            type="number"
            placeholder={this.props.placeholder}
            value={this.state.value}
            disabled={this.props.disabled}
            onChange={(e) => { this.onNumberChanged(e); }}
            inputRef={(ref: Object) => { this.input = ref; }}
            onFocus={(event: Object) => {event.target.select();}}
          />
        </Col>
        <Col sm={7}>
          <FormControl
            className="slider"
            type="range"
            min={this.props.min}
            max={this.props.max}
            value={this.state.value}
            step={this.props.step}
            disabled={this.props.disabled}
            onChange={(e) => { this.onNumberChanged(e); }}
          />
        </Col>
      </FormGroup>
    );
  }
}


export default SliderInput;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/SpeechAndLanguage/components/SliderInput/SliderInput.js